// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getValuesFromEnum<E extends { [key: string | number]: any }>(jsEnum: E): E[keyof E][] {
    return Object.values(jsEnum);
}
